// extracted by mini-css-extract-plugin
export default {"dualPowerSourceCardContainer":"power-energy-source_dualPowerSourceCardContainer__oFBAb"};